<!-- 自定义轮播图 -->
<template>
    <el-carousel :height="height" v-if="$utils.isArray(bannerList)" :indicator-position="bannerList.length==1?'none':''" :arrow="bannerList.length==1?'never':''">
      <el-carousel-item v-for="(item,index) in bannerList" :key="index">
        <a :class="{pointer:item.jumpUrl}" @click="clickImageJump(item.jumpUrl,item.bannerid)">
          <div :class="{general_banner_img_kuang:isMainBanner}">
            <img :width="imgWidth" :height="imgHeight" :src="fileUrl+item.imgUrl">
          </div>
        </a>
      </el-carousel-item>
    </el-carousel>
</template>

<script>
    export default {
        props:{
            bannerList:{
                type:Array,
                default:()=>{
                    return [];
                }
            },
            fileUrl:{//文件前缀
                type:String,
                default:""
            },
            height:{
                type:String,
                default:''
            },
            imgHeight:{//图片的高度
                type:String,
                default:''
            },
            imgWidth:{//图片的宽度
                type:String,
                default:''
            },
            isMainBanner:{//主要用于宽度适配
                type:Boolean,
                default:true,
            },
        },
        data() {
            return {
            }
        },
        created(){
        },
        methods:{
            clickImageJump(url,bannerid){
                this.$emit("clickImageJump",url,bannerid);
            },
        }
    }
</script>

<style lang="less" scoped>
.pointer{
    cursor: pointer;
}

.general_banner_img_kuang{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100vw;
    min-width: 1200px;
    height: 100%;
    font-size: 8rem;
    // background: hsl(240, 100%, 67%);
    color: hsl(0, 0%, 100%);
    position: relative;
}
/deep/ .el-carousel__button{
    width:6px;
    height: 6px;
    border-radius: 50%;
    overflow: hidden;
}
// img{
//     width:100%;
//     height: 100%;
// }
.el-carousel__item h3 {
    color: #475669;
    font-size: 14px;
    opacity: 0.75;
    line-height: 150px;
    margin: 0;
}

.el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n+1) {
    background-color: #d3dce6;
}
</style>